<div dir="rtl" style="text-align: right">
    <p-tabView class="main-tabview" [ngClass]="{ navbar_opened: navbarOpened }" (onChange)="handleChange($event)">
        <p-tabPanel
            *ngFor="let item of finalArray; let i = index"
            [header]="item.title"
            [headerStyleClass]="item.isHaveValue ? 'main-tabview__tabview_have-value' : ''"
            [selected]="item.cb_id == 57"
            [rightIcon]="item.icon"
        >
            <div [ngSwitch]="item.cb_id">
                <app-custcardview42 *ngSwitchCase="42" [customerId]="customerin.customer_id"></app-custcardview42>
                <app-custcardview44 *ngSwitchCase="44" [customerId]="customerin.customer_id"></app-custcardview44>
                <app-custcardview45 *ngSwitchCase="45" [customerId]="customerin.customer_id"></app-custcardview45>
                <app-custcardview46
                    *ngSwitchCase="46"
                    [customerId]="customerin.customer_id"
                    [customerFl]="custcard_3.firstName + ' ' + custcard_3.lastName"
                ></app-custcardview46>
                <app-custcardview43 *ngSwitchCase="43" [customerId]="customerin.customer_id"></app-custcardview43>
                <app-custcardview57 *ngSwitchCase="57" [customerId]="customerin.customer_id"></app-custcardview57>
            </div>
        </p-tabPanel>
        <p-tabPanel headerStyleClass="last-tabview-panel"></p-tabPanel>
    </p-tabView>
</div>

<div class="mobile-footer">
    <div class="footer__background" [ngClass]="{ background_visible: backgroundVisible }" (click)="backgroundHide()"></div>
    <div class="footer__more-section footer__section" [ngClass]="{ 'more-section_opened': moreOpened }">
        <button class="section__item" (click)="openEditCustomer()" [disabled]="isDisabled(21)">
            עריכת לקוח/ה
            <i class="footer-item__icon fa-regular fa-user-pen"></i>
        </button>

        <button class="section__item" [disabled]="isDisabled(22)">
            קביעת תור חדש
            <i class="footer-item__icon fa-regular fa-calendar-lines-pen"></i>
        </button>

        <button class="section__item" [disabled]="isDisabled(23)">
            מעבר לחשבון בקופה
            <i class="footer-item__icon fa-regular fa-cart-shopping"></i>
        </button>

        <button class="section__item" [disabled]="isDisabled(24)">
            שלח הזמנה ל-iTor
            <img class="icon-itor" src="/assets/img/icon-logo-itor.svg" />
        </button>

        <button class="section__item" [disabled]="isDisabled(25)">
            שלח לינק מילוי פרטים
            <i class="footer-item__icon fa-regular fa-share"></i>
        </button>
    </div>
    <div class="footer__communication footer__section" [ngClass]="{ communication_opened: communicationOpened }">
        <a
            class="section__item"
            href="{{ getWhatsAppLink() }}"
            target="_blank"
            (click)="backgroundHide()"
            [ngClass]="{ section__item_disabled: isDisabled(20) || !(custcard_3 && custcard_3.pelephone) }"
        >
            WhatsApp
            <i class="footer-item__icon fa-regular fa-circle-phone"></i>
        </a>

        <button class="section__item" (click)="openDialog()" [disabled]="isDisabled(20) || !(custcard_3 && custcard_3.pelephone)">
            שלח סמס
            <i class="footer-item__icon fa-regular fa-comment-sms"></i>
        </button>

        <a
            class="section__item"
            href="tel:{{ custcard_3.pelephone }}"
            (click)="backgroundHide()"
            [ngClass]="{ section__item_disabled: isDisabled(20) || !(custcard_3 && custcard_3.pelephone) }"
        >
            להתקשר
            <i class="footer-item__icon fa-regular fa-phone"></i>
        </a>
    </div>
    <div class="footer__menu">
        <button class="footer__item" (click)="footerOpen(3)">
            <i *ngIf="!communicationOpened" class="fa-regular fa-comments footer-item__icon"></i>
            <i *ngIf="communicationOpened" class="fa-duotone fa-comments footer-item__icon footer-item__icon_active"></i>
            <span class="footer-item__text">פנייה ללקוח/ה</span>
        </button>

        <button class="footer__item" (click)="footerOpen(2)">
            <i *ngIf="!moreOpened" class="fa-regular fa-folders footer-item__icon"></i>
            <i *ngIf="moreOpened" class="fa-duotone fa-folders footer-item__icon footer-item__icon_active"></i>
            <span class="footer-item__text">פעולות</span>
        </button>

        <button class="footer__item" (click)="footerOpen(1)">
            <img *ngIf="!navbarOpened" src="assets/img/footer_panels.svg" class="footer-item__icon" alt="" />
            <img *ngIf="navbarOpened" src="assets/img/footer_panels_active.svg" class="footer-item__icon footer-item__icon_active" alt="" />
            <span class="footer-item__text">מידע נוסף</span>
        </button>
    </div>
</div>
